import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "lit/directives/when.js";

@customElement("loading-button")
export class LoadingButtonElement extends LitElement {
    @property({ type: Boolean })
    public disabled: boolean = false;

    @property({ type: Boolean })
    public loading: boolean = false;

    @property({ type: String })
    public loadingText: string = "Processing...";

    @property({ type: String })
    public buttonText?: string;

    protected override render() {
        return html`
            <button
                ?disabled="${this.disabled}"
                @click="${this.handleClick}"
                class="cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-400 justify-self-end rounded transition bg-mcr-purple hover:bg-mcr-purple-600 px-4 py-2 text-white lg:col-span-12 flex">
                ${when(
                    this.loading,
                    () => html`<svg class="mr-3 -ml-1 size-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                        ${this.loadingText}`,
                    () => this.buttonText ?? "Click me"
                )}
            </button>
        `;
    }

    protected handleClick(event: PointerEvent) {
    }

    protected override createRenderRoot() {
        return this;
    }
}